import React from "react";
import { Car, AlertTriangle } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function AracKontekstBar({
    arac,
    marka,
    model,
    modelYili,
    onMarka,
    onModel,
    onModelYili,
    seciliDosya,
}) {
    const eksik = arac?.eksik_alanlar?.length > 0;
    const tam = arac?.tam_etiket;

    return (
        <div
            className={`rounded-xl border p-4 ${
                eksik
                    ? "border-amber-500/30 bg-amber-500/5"
                    : "border-emerald-500/20 bg-emerald-500/5"
            }`}
        >
            <div className="flex flex-wrap items-center gap-3 mb-3">
                <Car className="h-5 w-5 text-[#D4AF37]" />
                <span className="text-sm font-medium text-white">Araç bağlamı (piyasa taraması)</span>
                {tam && !eksik ? (
                    <span className="text-xs text-emerald-300/90 ml-auto">{tam}</span>
                ) : null}
                {seciliDosya?.plaka ? (
                    <span className="text-xs text-slate-500">{seciliDosya.plaka}</span>
                ) : null}
            </div>

            {eksik ? (
                <p className="text-xs text-amber-200/90 flex items-center gap-2 mb-3">
                    <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
                    Parça internet araştırması için marka (ve tercihen model) girin veya dosya seçin.
                </p>
            ) : (
                <p className="text-xs text-slate-500 mb-3">
                    Tüm parçalar bu araç için N11 ve web’de taranır; ekspertiz tutarı piyasa ile
                    karşılaştırılır.
                </p>
            )}

            <div className="grid sm:grid-cols-3 gap-3">
                <div>
                    <label className="text-[10px] text-slate-500 uppercase tracking-wider">Marka</label>
                    <Input
                        value={marka}
                        onChange={(e) => onMarka(e.target.value)}
                        placeholder="örn. Renault"
                        className="mt-1 bg-[#0f172a] border-white/10 h-9 text-sm"
                    />
                </div>
                <div>
                    <label className="text-[10px] text-slate-500 uppercase tracking-wider">Model</label>
                    <Input
                        value={model}
                        onChange={(e) => onModel(e.target.value)}
                        placeholder="örn. Megane"
                        className="mt-1 bg-[#0f172a] border-white/10 h-9 text-sm"
                    />
                </div>
                <div>
                    <label className="text-[10px] text-slate-500 uppercase tracking-wider">
                        Model yılı
                    </label>
                    <Input
                        type="number"
                        value={modelYili}
                        onChange={(e) => onModelYili(e.target.value)}
                        placeholder="2020"
                        className="mt-1 bg-[#0f172a] border-white/10 h-9 text-sm"
                    />
                </div>
            </div>
        </div>
    );
}
